import { Badge, type BadgeTone } from '@/components/ui/Badge';
import type { RequestStatus } from '@/types/api';

const STATUS_TONE: Record<RequestStatus, BadgeTone> = {
  open: 'gray',
  submitted: 'yellow',
  under_review: 'blue',
  accepted: 'green',
  rejected: 'red',
  overdue: 'red-soft',
  cancelled: 'gray-strong',
};

const STATUS_LABEL: Record<RequestStatus, string> = {
  open: 'Open',
  submitted: 'Submitted',
  under_review: 'Under review',
  accepted: 'Accepted',
  rejected: 'Rejected',
  overdue: 'Overdue',
  cancelled: 'Cancelled',
};

export function RequestStatusBadge({ status }: { status: RequestStatus }) {
  return <Badge tone={STATUS_TONE[status]}>{STATUS_LABEL[status]}</Badge>;
}
